// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__wws3s","button":"footer_button__Isc2m","text":"footer_text__bUuUg"};